const _st = { data: {} }
export class BenQuery {
  static getLocationPathname() {
    return document.location.pathname
  }

  static setData(key: string, value: any) {
    _st.data[key] = value
  }

  static paseJson(data: string) {
    try {
      return JSON.parse(data)
    } catch (error) {
      return null
    }
  }

  static getCookie(name) {
    const nameEQ = encodeURIComponent(name) + '='
    const ca = document.cookie.split(';')
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i].trim()
      if (c.indexOf(nameEQ) === 0) {
        return decodeURIComponent(c.substring(nameEQ.length))
      }
    }
    return null
  }

  static getData(key: string, { clear = true } = {}) {
    const value = _st.data[key] || null
    if (clear) delete _st.data[key]
    return value
  }

  static getWinValue(key) {
    const obj = window['$BenQuery'] || {}
    return obj[key] || key
  }

  static sleep(time = 1000) {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve(true)
      }, time)
    })
  }

  static nextTick() {
    return new Promise((resolve) => {
      requestAnimationFrame(() => {
        resolve('success')
      })
    })
  }

  static query(selector: string, { type = HTMLElement, scope = document as Document | HTMLElement } = {}, onlyOne = false) {
    return Array.from(scope.querySelectorAll(selector)).filter((item) => item instanceof type)
  }

  static isRTL(dom: HTMLElement): boolean {
    if (!dom) return false
    const dir = window.getComputedStyle(dom).direction
    return dir === 'rtl'
  }

  static isOverflow(dom: Element) {
    return dom.scrollHeight > dom.clientHeight
  }

  static createSvgUse({ icon, className = '' }) {
    const svgNS = 'http://www.w3.org/2000/svg' // SVG核心命名空间
    const xlinkNS = 'http://www.w3.org/1999/xlink' // xlink命名空间
    const $svg = document.createElementNS(svgNS, 'svg')
    if (className) $svg.setAttribute('class', className) // 设置类名
    const $use = document.createElementNS(svgNS, 'use')
    const id = `#${icon}`
    $use.setAttributeNS(xlinkNS, 'xlink:href', id)
    $svg.appendChild($use)
    return $svg
  }
  static checkOverflow(el) {
    return el.scrollWidth > el.clientWidth
  }

  static createElement(tag: string, { className = '', classList = [] as Array<string> } = {}) {
    const $dom = document.createElement(tag)
    if (className) $dom.className = className
    if (classList.length) $dom.classList.add(...classList)
    return $dom
  }

  static htmlToElement(html) {
    const template = document.createElement('template')
    template.innerHTML = html.trim()
    return template.content.firstElementChild
  }

  static slideDown(el: HTMLElement) {
    const transitionDuration = 300
    el.style.maxHeight = `${el.scrollHeight}px`
    setTimeout(() => {
      el.style.maxHeight = 'none'
    }, transitionDuration)
  }

  static slideUp(el: HTMLElement) {
    el.style.maxHeight = `${el.scrollHeight}px`
    el.offsetHeight
    el.style.maxHeight = '0px'
  }

  static toggleSlide(el: HTMLElement) {
    const transitionDuration = 300
    const maxHeight = el.style.maxHeight
    // 判断是否展开
    const isOpen = parseFloat(maxHeight) > 0 || maxHeight === 'none'
    if (isOpen) {
      // 收起：先设当前高度，再过渡到0（解决height:auto过渡失效）
      el.style.maxHeight = `${el.scrollHeight}px`
      // 强制重绘
      el.offsetHeight
      el.style.maxHeight = '0px'
    } else {
      // 展开：直接赋值内容高度
      el.style.maxHeight = `${el.scrollHeight}px`
      // 动画结束后清除maxHeight，适配内容动态变化
      setTimeout(() => {
        el.style.maxHeight = 'none'
      }, transitionDuration)
    }
    return !isOpen
  }

  static addHtml(el: HTMLElement, html, { method = 'prepend' as 'prepend' | 'append' } = {}) {
    const innerHtml = el.innerHTML
    if (method === 'prepend') {
      el.innerHTML = html + innerHtml
    } else {
      el.innerHTML = innerHtml + html
    }
  }

  static async ajax(url, { method = 'POST' as 'GET' | 'POST', data = {} } = {}): Promise<any> {
    return new Promise((resolve) => {
      const xhr = new XMLHttpRequest()
      let requestUrl = url
      if (method.toUpperCase() === 'GET' && Object.keys(data).length > 0) {
        const params = new URLSearchParams(data)
        requestUrl += '?' + params.toString()
      }
      xhr.open(method, requestUrl, true)
      if (method.toUpperCase() === 'POST') {
        xhr.setRequestHeader('Content-Type', 'application/json;charset=utf-8')
      }
      xhr.onreadystatechange = function () {
        if (xhr.readyState === XMLHttpRequest.DONE) {
          if (xhr.status >= 200 && xhr.status < 300) {
            let response
            try {
              response = JSON.parse(xhr.responseText)
            } catch (e) {
              response = xhr.responseText
            }
            resolve(response)
          } else {
            console.log(xhr.statusText)
          }
        }
      }
      xhr.onerror = function () {
        console.log('请求失败')
      }
      const sendData = method.toUpperCase() === 'POST' ? JSON.stringify(data) : null
      xhr.send(sendData)
    })
  }
}
